import ParseError from '../errors/ParseError';
import NotImplementedError from '../errors/NotImplementedError';
import ValueError from '../errors/ValueError';
import AssetsManager from '../assets_management/AssetsManager';
const PlotStatus = {
    AVAILABLE:4,
    COMING_SOON:3,
    FUTURE_RELEASE:6,
    SOLD_OR_UNAVAILABLE:2,
	RESERVED:8,
	EARLY_BIRD:9,
	EXCHANGED:10
};
PlotStatus.getValues = function(){
	return Object.values(PlotStatus).filter(value=>typeof(value)==='number');
};
PlotStatus.getDescription = function(plotStatus){
	
	const cssName = PlotStatus.getCssName(plotStatus);
	const customCssVariableName = `--status-${cssName}-text`;
	const text = getComputedStyle(document.documentElement).getPropertyValue(customCssVariableName);
	if(text&&text.length>0)
		return text;
	if(plotStatus===PlotStatus.AVAILABLE)
		return "Available";
	if( plotStatus===PlotStatus.COMING_SOON)
		return "Coming Soon";
	if( plotStatus===PlotStatus.FUTURE_RELEASE)
		return "Future Release";
	if( plotStatus===PlotStatus.SOLD_OR_UNAVAILABLE)
		return "Sold";
	if( plotStatus===PlotStatus.EXCHANGED)
		return "Exchanged";
	if( plotStatus===PlotStatus.RESERVED)
		return "Reserved";
	if( plotStatus===PlotStatus.EARLY_BIRD)
		return "Early Bird";
	return '';
};
PlotStatus.getCssName = function(plotStatus){
	if(plotStatus===PlotStatus.AVAILABLE){
		return "available";
	}
	if( plotStatus===PlotStatus.COMING_SOON)
		return "coming-soon";
	if( plotStatus===PlotStatus.FUTURE_RELEASE)
		return "future-release";
	if( plotStatus===PlotStatus.SOLD_OR_UNAVAILABLE)
		return "sold-or-unavailable";
	if( plotStatus===PlotStatus.EXCHANGED)
		return "exchanged";
	if( plotStatus===PlotStatus.RESERVED)
		return "reserved";
	if( plotStatus===PlotStatus.EARLY_BIRD)
		return "early-bird";
	return '';
};
PlotStatus.toStr = function(plotStatus){
	if( plotStatus===PlotStatus.AVAILABLE)
		return "available";
	if( plotStatus===PlotStatus.COMING_SOON)
		return "comingSoon";
	if( plotStatus===PlotStatus.FUTURE_RELEASE)
		return "futureRelease";
	if( plotStatus===PlotStatus.SOLD_OR_UNAVAILABLE)
		return "soldOrUnavailable";
	if( plotStatus===PlotStatus.EXCHANGED)
		return "exchanged";
	if( plotStatus===PlotStatus.RESERVED)
		return "reserved";
	if( plotStatus===PlotStatus.EARLY_BIRD)
		return "earlyBird";
	return '';
};
PlotStatus.getConfiguratorIconRelativePath = function(plotStatus, configuration){
		const plotStatusConfiguration = configuration.plotStatusConfigurations.getFromPlotStatus(plotStatus);
		return `icons/${plotStatusConfiguration?.configuratorIconFileName}`;
};
PlotStatus.parse = function(value){
	if(value===undefined||value===null)
		throw ValueError('value was None');
	if(typeof(value)==='string')
		return PlotStatus.parseFromString(value);
	if(typeof(value)==='number')
		return PlotStatus.parseFromInt(value);
	throw new ParseError(`Could not parse value "${value}" to PlotStatus"`);
};
PlotStatus.parseFromString = function(value){
	value = value.toLowerCase();
	if (value==='available')
		return PlotStatus.AVAILABLE;
	if (['coming soon', 'comingsoon', 'coming_soon', 'coming', 'soon'].indexOf(value)>=0){
		return PlotStatus.COMING_SOON;
	}
	if (['future release', 'futurerelease', 'future_release', 'future'].indexOf(value)>=0){
		return PlotStatus.FUTURE_RELEASE;
	}
	if (['sold or unavailable', 'soldorunavailable','sold_or_unavailable', 'sold', 'unavailable'].indexOf(value)>=0){
		return PlotStatus.SOLD_OR_UNAVAILABLE;
	}
	if (['reserved'].indexOf(value)>=0){
		return PlotStatus.RESERVED;
	}
	if (['exchanged'].indexOf(value)>=0){
		return PlotStatus.EXCHANGED;
	}
	if (value.indexOf('early')>=0){
		return PlotStatus.EARLY_BIRD;
	}
	return PlotStatus.AVAILABLE;
};
PlotStatus.parseFromInt = function(value){
	return value;
};
export default PlotStatus;